import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import ViewProfile from '../Profile/ViewProfile';
import ViewProfileDetail from '../Profile/ViewProfileDetail'
import Add from './Add';

const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'Approved', value: 'Approved' },
    { key: 'Pending', value: 'Pending' },
    { key: 'Rejected', value: 'Rejected' },
]
const searchBy = [
    { key: 'Name', value: 'FullName' },
    { key: 'Partner-ID', value: 'ProfileUniqeID' },
    { key: 'Phone Number', value: 'PhoneNumber' },
    { key: 'Email-Id', value: 'EmailId' },
    { key: 'City', value: 'City' },
    { key: 'State', value: 'State' },
    { key: 'Status', value: 'Status' }
];

class AllList extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'FullName',

        modalShow: false,
        alert: 0,
        alertMessage: '',
        data: [],
        selectedRow: [],
        flag: true,
        showAdd: false,
        showEdit: false
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {

        if (this.state.search_by === 'PhoneNumber' && this.state.search_key) {
            var SearchKey = '+91'+this.state.search_key.substring(this.state.search_key.length - 10)
        } else {
            var SearchKey = this.state.search_key;
        }

        let bodyData = {
            search_key: SearchKey,
            search_by: this.state.search_by,
            userRole: 'Admins',
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        
        await RestServices.getAllProfilesPagination(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                //console.log(responseData)
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            flag: false,
                            alert: 0
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    cancleAction = () => {
        this.loadData();
        if (this._isMounted) {
            this.setState({ showAdd: false, showEdit: false });
        }
    };

    showViewProfile = (rowData) => {
        if (this._isMounted) {
            this.setState({ showEdit: true, selectedRow: rowData });
        }
    };

    render() {
        const options = {
            actionsColumnIndex: -1
        };

        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({ showAdd: true, selectedRow: false });
                    }
                }
            }
        ];

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                {!this.state.showEdit && !this.state.showAdd && (
                    <div>
                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Manage Admins
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    {this.state.search_by =='Status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}
                                    {this.state.search_by !=='Status' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Store Admins"
                            columns={[
                                {
                                    title: 'Name',
                                    field: 'FullName',
                                    render: (row) => (
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                color: 'blue'
                                            }}
                                            onClick={(e) =>
                                                this.showViewProfile(row)
                                            }
                                        >
                                            {row.FullName}
                                        </div>
                                    )
                                },
                                { title: 'Partner-ID', field: 'ProfileUniqeID' },
                                { title: 'Phone Number', field: 'PhoneNumber' },
                                { title: 'Email-Id', field: 'EmailId' },
                                { title: 'City/State', field: 'City',
                                render: (row) => row.City+'/'+row.State }, 
                                { title: 'CreatedAt', field: 'CreatedAt',
                                render: (row) => getFormattedDateTime(row.CreatedAt) },
                                {
                                    title: 'Status',
                                    field: 'Status',
                                    lookup: {
                                        PENDING_VERIFICATION: 'Pending',
                                        Rejected: 'Rejected',
                                        Approved: 'Approved'
                                    }
                                }
                            ]}
                            data={this.state.data}
                            actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.data.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.data.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}

                {this.state.showEdit && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.cancleAction}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Profile Details
                            </h4>
                        </Row>

                        
                        <ViewProfileDetail
                            profileFullName={this.state.selectedRow.FullName}
                            selectedUserRole="Admins"
                            UniqeID={this.state.selectedRow.ProfileUniqeID}
                            {...this.props}
                        />
                        {/*<ViewProfile
                            profileFullName={this.state.selectedRow.FullName}
                            selectedUserRole="Admins"
                            UniqeID={this.state.selectedRow.ProfileUniqeID}
                            {...this.props}
                            />*/}
                    </div>
                )}

                {this.state.showAdd && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.cancleAction}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Profile Details
                            </h4>
                        </Row>

                        <Add {...this.props} />
                    </div>
                )}
            </Container>
        );
    }
}

export default AllList;
